import { httpClientVendasCoreBff } from 'vendas-core/shared/services'
import { type WebhookItem } from 'webhooks/shared/entities'

import { useInfiniteQueryRequest } from '~/ui/hooks/utils'

interface WebhookPagination {
  currentPage: number
  pageSize: number
  totalItems: number
  totalPage: number
}

interface WebhookSettingsListResponse {
  items: WebhookItem[]
  pagination: WebhookPagination
}

async function getWebhookSettings(paymentProfileId: string | undefined, page: number) {
  return httpClientVendasCoreBff<WebhookSettingsListResponse>({
    url: `/v1/payment-profile/${paymentProfileId}/webhooks/settings`,
    method: 'GET',
    params: { page, size: 10 }
  })
}

export function useGetWebhookSettings(paymentProfileId: string | undefined, options?: { enabled?: boolean }) {
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, ...rest } =
    useInfiniteQueryRequest<WebhookSettingsListResponse>(
      ['useGetWebhookSettings', paymentProfileId],
      ({ pageParam = 1 }) => getWebhookSettings(paymentProfileId, pageParam as number),
      {
        getNextPageParam: lastPage => {
          const { currentPage, totalPage } = lastPage.data.pagination
          return currentPage < totalPage ? currentPage + 1 : undefined
        },
        enabled: Boolean(paymentProfileId) && (options?.enabled ?? true)
      }
    )

  const items = data?.pages.flatMap(page => page.data.items ?? []) ?? []

  return { items, fetchNextPage, hasNextPage, isFetchingNextPage, ...rest }
}
